export default __webpack_public_path__ + "static/media/BatchIcon.7ff1edb1.svg";